import { Injectable } from '@angular/core';
import * as signalR from '@aspnet/signalr'; // or from "@microsoft/signalr" if you are using a new library
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';
import { urlApi, urlSignalR } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  hubClient: HubConnection;

  constructor() {}

  public configurarHub(hub: string): void {
    let url = `${urlSignalR}/${hub}`;
    this.hubClient = new HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Debug)
      .withUrl(url, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .build();
  }
}
